import { Checkbox } from '@mui/material'
import {
  Attribute as AttributeProp,
  AttributeType,
} from '@returnmates/client-core/src/graphql/generated/api'
import Input from '@returnmates/ui-core/src/components/Input'
import { memo, useCallback } from 'react'

import Remove from '../../images/icons/remove'
import Select from '../../Select'
import useStyles from '../styles'

const ATTRIBUTES_SELECT = {
  [AttributeType.TEXT]: 'Text',
  [AttributeType.INTEGER]: 'Integer',
}

interface Props {
  attribute: AttributeProp
  removeAttribute: (id: string) => void
  onAttributeChange: (attribute: AttributeProp) => void
}

function Attribute({ attribute, removeAttribute: removeAttributeProp, onAttributeChange }: Props) {
  const classes = useStyles({})

  const onNameChange = useCallback(val => onAttributeChange({ ...attribute, name: val }), [
    attribute,
    onAttributeChange,
  ])

  const onTitleChange = useCallback(val => onAttributeChange({ ...attribute, title: val }), [
    attribute,
    onAttributeChange,
  ])

  const onPlaceholderChange = useCallback(
    val => onAttributeChange({ ...attribute, placeholder: val }),
    [attribute, onAttributeChange],
  )

  const onTooltipChange = useCallback(val => onAttributeChange({ ...attribute, tooltip: val }), [
    attribute,
    onAttributeChange,
  ])

  const onTypeChange = useCallback(e => onAttributeChange({ ...attribute, type: e.target.value }), [
    attribute,
    onAttributeChange,
  ])

  const onIsRequiredChange = useCallback(
    e => onAttributeChange({ ...attribute, isRequired: e.target.checked }),
    [attribute, onAttributeChange],
  )

  const removeAttribute = useCallback(() => removeAttributeProp(attribute.id as string), [
    attribute,
    removeAttributeProp,
  ])

  return (
    <div className={classes.attribute}>
      <div className={classes.attributeBlock}>
        <Input
          placeholder="name"
          classes={{
            textField: classes.input,
          }}
          onChange={onNameChange}
          value={attribute.name || ''}
        />
        <Input
          placeholder="title"
          classes={{
            textField: classes.input,
          }}
          onChange={onTitleChange}
          value={attribute.title || ''}
        />
        <Remove onClick={removeAttribute} className={classes.removePriceIcon} />
      </div>
      <div className={classes.attributeBlock}>
        <Input
          placeholder="placeholder"
          classes={{
            textField: classes.input,
          }}
          onChange={onPlaceholderChange}
          value={attribute.placeholder || ''}
        />
        <Input
          placeholder="tooltip"
          classes={{
            textField: classes.input,
          }}
          onChange={onTooltipChange}
          value={attribute.tooltip || ''}
        />
      </div>
      <div className={classes.attributeBlock}>
        <Select
          value={attribute.type || ''}
          onChange={onTypeChange}
          values={ATTRIBUTES_SELECT}
          placeholder="Select type"
          className={classes.select}
        />
        <Checkbox checked={attribute.isRequired || false} onClick={onIsRequiredChange} />
        <span>Is required?</span>
      </div>
    </div>
  )
}

export default memo(Attribute)
